import api from "./index";

export async function createCounters(params, body) {
  return api.post(`/desks`, body, { params });
}

export async function updateCounters(id, body) {
  return api.put(`/desks/${id}`, body);
}

export async function getCounters(params) {
  return api.get(`/desks`, { params: params });
}

export async function getCounter(id) {
  return api.get(`/desks/${id}`);
}

export async function deleteCounters(id) {
  return api.delete(`/desks/${id}`);
}

export async function importUsers(id, body) {
  return api.post(`/desks/${id}/attendants/import`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function createCounterCalendar(id) {
  return api.post(`/desks/${id}/calendar`);
}

export async function getDeskWorkingHours(id, params) {
  return api.get(`/desks/${id}/working-hours`, { params });
}

export async function postDeskWorkingHours(id, body) {
  return api.post(`/desks/${id}/working-hours`, body);
}

export async function getCounterHistory(deskID, params) {
  return api.get(`/desks/history`, { params: { deskID, ...params } });
}
